/*jshint esversion: 8 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import { updateLocalStorageFields } from '../../../utils/LocalStorageHandler';

// store
import { observer } from "mobx-react";
import LocalStore from "./LocalStore";
import store from "../../../components/stores/Store";

const styles = {};

class FilterDialog extends Component {
  constructor() {
    super();
    this.state = {};
    this.switchColumnDisplay = this.switchColumnDisplay.bind(this);
  }

  componentDidMount() { }

  switchColumnDisplay(sid) {
    const tableFields = LocalStore.tableFields;
    for (let index = 0; index < tableFields.length; index++) {
      const element = tableFields[index];
      if (element.sid === sid) {
        tableFields[index].display = !tableFields[index].display;
        break;
      }
    }
    LocalStore.set({ tableFields: tableFields });

    const comfortableHousingTableFilter = {};
    for (let index = 0; index < tableFields.length; index++) {
      const element = tableFields[index];
      comfortableHousingTableFilter[element.sid] = element.display;
    }

    updateLocalStorageFields({
      comfortableHousingTableFilter,
    })

    // 清除对应查找内容
    const selections = store.selections;
    selections[sid] = '';
    store.setSelections(selections);
  }


  render() {
    // console.log(`----- LocalStore.columnFilterDialogOpen: `, LocalStore.columnFilterDialogOpen);
    return (
      <Dialog fullWidth maxWidth='xs'
        onClose={() => LocalStore.switchFilterDialog()} open={LocalStore.columnFilterDialogOpen}>
        <DialogTitle>请选择需要显示的列{LocalStore.columnFilterDialogOpen}</DialogTitle>
        <List >
          {LocalStore.tableFields.map((headCell) => {
            if (!headCell.canFilter) return null;
            const backgroundColor = headCell.display ? '#ddd' : '#fff';
            const listItemText = (headCell.display ? '已显示 - ' : '已隐藏 - ') + headCell.label;
            return (
              <ListItem
                button
                key={headCell.id}
                onClick={(event) => this.switchColumnDisplay(headCell.sid)}
                style={{ backgroundColor: backgroundColor }}
              >
                <ListItemText primary={listItemText} />
              </ListItem>
            )
          })}
          <ListItem button onClick={() => LocalStore.switchFilterDialog()} >
            <ListItemText primary="关闭弹框" style={{ color: 'red' }} />
          </ListItem>
        </List>
      </Dialog>
    );
  }
}

const FilterDialogObserver = observer(FilterDialog);

FilterDialogObserver.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FilterDialogObserver);
